import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  TextField,
} from "@mui/material";
import { CloudUpload, PictureAsPdf } from "@mui/icons-material";
import axios from "axios";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;

const UploadPdfReport = ({ report, subchecklist }) => {
  const [unitCode, setUnitCode] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [date, setDate] = useState("");
  const [selectedFiles, setSelectedFiles] = useState({});
  const [uploading, setUploading] = useState(false);
  const [extractedText, setExtractedText] = useState("");
  const [filePath, setFilePath] = useState("");

  const handleFileChange = (idx, file) => {
    console.log("idx", idx);
    setSelectedFiles((prev) => ({
      ...prev,
      [idx]: file,
    }));
  };
  function convertDateTime(inputDateTime) {
    const date = new Date(inputDateTime);

    // Extract individual components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    // Format the output
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }
  // Upload PDF file
  const handleUpload = async () => {
    if (!date || !unitCode || !empCode) {
      return alert("Please fill all fields");
    }

    if (Object.keys(selectedFiles).length === 0) {
      return alert("Please select at least one PDF");
    }

    setUploading(true);

    const formData = new FormData();
    formData.append("unitCode", unitCode);
    formData.append("empCode", empCode);
    formData.append("ckId", report.Id);
    formData.append("date", convertDateTime(date));
    formData.append("remark", "From Dashboard");

    // Attach all PDFs with unique keys
    Object.entries(selectedFiles).forEach(([subId, file]) => {
      formData.append(`pdfFile_${subId}`, file);
      formData.append(`subId_${subId}`, subId); // send subId explicitly
    });

    try {
      const response = await axios.post(
        `https://www.apsgroupapp.com/ExpressAPI/facility/upload-facility-pdf`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setFilePath(response.data.filePath);
      alert("Files uploaded successfully!");
      setUnitCode("");
      setEmpCode("");
      setSelectedFiles({});
    } catch (error) {
      alert("Error uploading files!");
    } finally {
      setUploading(false);
    }
  };
  // Extract text from uploaded PDF
  const handleExtractText = async () => {
    if (!filePath) return alert("Upload a file first!");

    try {
      const fileName = filePath.split("/").pop(); // Extract filename from path
      const response = await axios.get(
        `http://localhost:5000/extract/${fileName}`
      );
      setExtractedText(response.data.text);
    } catch (error) {
      alert("Error extracting text!");
    }
  };

  return (
    <Card
      sx={{
        maxWidth: "100%",
        mx: "auto",
        mt: 4,
        p: 2,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1, // Keeps spacing between elements compact
        flexWrap: "nowrap", // Ensures single-row layout
        overflowX: "auto", // Enables horizontal scrolling if needed
      }}
    >
      <TextField
        label="Unit Code"
        variant="outlined"
        size="small"
        value={unitCode || ""}
        onChange={(e) => setUnitCode(e.target.value)}
        sx={{ width: 200 }}
      />

      <TextField
        label="Employee Code"
        variant="outlined"
        size="small"
        value={empCode || ""}
        onChange={(e) => setEmpCode(e.target.value)}
        sx={{ width: 200 }}
      />

      <TextField
        variant="outlined"
        size="small"
        type="datetime-local"
        value={date || ""}
        onChange={(e) => setDate(e.target.value)}
        sx={{ width: 200 }}
      />

      <input
        type="file"
        accept="application/pdf"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="file-input"
      />
      {subchecklist.map((item) => {
        const inputId = `file-input-${item.subid}`;
        return (
          <React.Fragment key={item.subid}>
            <input
              type="file"
              accept="application/pdf"
              onChange={(e) => handleFileChange(item.subid, e.target.files[0])}
              style={{ display: "none" }}
              id={inputId}
            />
            <label htmlFor={inputId}>
              <Button
                variant="contained"
                component="span"
                startIcon={<CloudUpload />}
              >
                {item.MasterName}
              </Button>
            </label>

            {selectedFiles[item.subid] && (
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ width: 180 }}
              >
                {selectedFiles[item.subid].name}
              </Typography>
            )}
          </React.Fragment>
        );
      })}

      <Button
        variant="contained"
        color="primary"
        onClick={handleUpload}
        disabled={uploading}
        sx={{ minWidth: 150 }}
      >
        {uploading ? <CircularProgress size={24} /> : "Upload"}
      </Button>
    </Card>
  );
};

export default UploadPdfReport;
